module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-BookItalic.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-BookItalic.eot
 ** module id = 353
 ** module chunks = 0
 **/